import { render, staticRenderFns } from "./PartnersCommissionsContainer.vue?vue&type=template&id=27e91ae2&scoped=true&"
import script from "./PartnersCommissionsContainer.vue?vue&type=script&lang=ts&"
export * from "./PartnersCommissionsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersCommissionsContainer.vue?vue&type=style&index=0&id=27e91ae2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e91ae2",
  null
  
)

export default component.exports